import { useQuery } from '@tanstack/react-query';
import { TSubscriptionsResponse } from '@onesource/schemas';
import axios from '../axios';

const ENTITY = 'billing';

export const getMemberSubscriptionsQueryKey = (page: number, perPage: number) => [
  ENTITY,
  'subscriptions',
  page,
  perPage,
];

export const useGetMemberSubscriptionsQuery = (params: { page?: number; perPage?: number; enabled?: boolean }) => {
  const { page = 1, perPage = 10, enabled = true } = params;

  return useQuery<TSubscriptionsResponse>({
    queryKey: getMemberSubscriptionsQueryKey(page, perPage),
    queryFn: async () => {
      const req = await axios.get(`${ENTITY}/subscriptions`, { params: { page, perPage } });
      return req.data;
    },
    enabled,
  });
};
